import React, { createElement } from "react";
// This file provides the CSS custom properties for the Radix colors
// We're adding this to simulate the Radix colors in our demo
export const injectRadixColors = () => {
  const style = document.createElement("style");
  style.innerHTML = `
    :root {
      /* Slate */
      --slate-1: hsl(206, 30%, 98.8%);
      --slate-2: hsl(210, 16.7%, 97.6%);
      --slate-3: hsl(209, 13.3%, 95.3%);
      --slate-4: hsl(209, 12.2%, 93.2%);
      --slate-5: hsl(208, 11.7%, 91.1%);
      --slate-6: hsl(208, 11.3%, 88.9%);
      --slate-7: hsl(207, 11.1%, 85.9%);
      --slate-8: hsl(205, 10.7%, 78%);
      --slate-9: hsl(206, 6%, 56.1%);
      --slate-10: hsl(206, 5.8%, 52.3%);
      --slate-11: hsl(206, 6%, 43.5%);
      --slate-12: hsl(206, 24%, 9%);
      /* Indigo */
      --indigo-1: hsl(225, 60%, 99.4%);
      --indigo-2: hsl(223, 100%, 98.6%);
      --indigo-3: hsl(223, 98.4%, 97.1%);
      --indigo-4: hsl(223, 92.9%, 95%);
      --indigo-5: hsl(224, 87.1%, 92%);
      --indigo-6: hsl(224, 81.9%, 87.8%);
      --indigo-7: hsl(225, 77.4%, 82.1%);
      --indigo-8: hsl(226, 75.4%, 74.5%);
      --indigo-9: hsl(226, 70%, 55.5%);
      --indigo-10: hsl(226, 58.6%, 51.3%);
      --indigo-11: hsl(226, 55%, 45%);
      --indigo-12: hsl(226, 62%, 17%);
      /* Tomato */
      --tomato-1: hsl(10, 100%, 99.4%);
      --tomato-2: hsl(8, 100%, 98.4%);
      --tomato-3: hsl(8, 100%, 96.6%);
      --tomato-4: hsl(8, 100%, 94.3%);
      --tomato-5: hsl(8, 92.8%, 91%);
      --tomato-6: hsl(9, 84.7%, 86.3%);
      --tomato-7: hsl(10, 77.3%, 79.5%);
      --tomato-8: hsl(10, 71.6%, 71%);
      --tomato-9: hsl(10, 78%, 54%);
      --tomato-10: hsl(10, 71.5%, 50%);
      --tomato-11: hsl(10, 82%, 43.5%);
      --tomato-12: hsl(10, 50%, 13.5%);
      /* Jade */
      --jade-1: hsl(152, 81%, 96.1%);
      --jade-2: hsl(149, 80%, 93.7%);
      --jade-3: hsl(152, 76%, 89.8%);
      --jade-4: hsl(154, 75%, 84.6%);
      --jade-5: hsl(156, 73%, 79.1%);
      --jade-6: hsl(157, 71%, 74.1%);
      --jade-7: hsl(158, 68%, 69%);
      --jade-8: hsl(156, 66%, 60.4%);
      --jade-9: hsl(155, 44%, 49%);
      --jade-10: hsl(155, 46%, 44.3%);
      --jade-11: hsl(155, 46%, 39%);
      --jade-12: hsl(155, 40%, 14%);
    }
    /* Tailwind-like utility classes for our demo */
    .bg-slate-1 { background-color: var(--slate-1); }
    .bg-slate-2 { background-color: var(--slate-2); }
    .bg-slate-3 { background-color: var(--slate-3); }
    .bg-slate-4 { background-color: var(--slate-4); }
    .bg-slate-5 { background-color: var(--slate-5); }
    .bg-slate-6 { background-color: var(--slate-6); }
    .bg-slate-7 { background-color: var(--slate-7); }
    .bg-slate-8 { background-color: var(--slate-8); }
    .bg-slate-9 { background-color: var(--slate-9); }
    .bg-slate-10 { background-color: var(--slate-10); }
    .bg-slate-11 { background-color: var(--slate-11); }
    .bg-slate-12 { background-color: var(--slate-12); }
    .bg-indigo-1 { background-color: var(--indigo-1); }
    .bg-indigo-2 { background-color: var(--indigo-2); }
    .bg-indigo-3 { background-color: var(--indigo-3); }
    .bg-indigo-4 { background-color: var(--indigo-4); }
    .bg-indigo-5 { background-color: var(--indigo-5); }
    .bg-indigo-6 { background-color: var(--indigo-6); }
    .bg-indigo-7 { background-color: var(--indigo-7); }
    .bg-indigo-8 { background-color: var(--indigo-8); }
    .bg-indigo-9 { background-color: var(--indigo-9); }
    .bg-indigo-10 { background-color: var(--indigo-10); }
    .bg-indigo-11 { background-color: var(--indigo-11); }
    .bg-indigo-12 { background-color: var(--indigo-12); }
    .bg-tomato-1 { background-color: var(--tomato-1); }
    .bg-tomato-2 { background-color: var(--tomato-2); }
    .bg-tomato-3 { background-color: var(--tomato-3); }
    .bg-tomato-4 { background-color: var(--tomato-4); }
    .bg-tomato-5 { background-color: var(--tomato-5); }
    .bg-tomato-6 { background-color: var(--tomato-6); }
    .bg-tomato-7 { background-color: var(--tomato-7); }
    .bg-tomato-8 { background-color: var(--tomato-8); }
    .bg-tomato-9 { background-color: var(--tomato-9); }
    .bg-tomato-10 { background-color: var(--tomato-10); }
    .bg-tomato-11 { background-color: var(--tomato-11); }
    .bg-tomato-12 { background-color: var(--tomato-12); }
    .bg-jade-1 { background-color: var(--jade-1); }
    .bg-jade-2 { background-color: var(--jade-2); }
    .bg-jade-3 { background-color: var(--jade-3); }
    .bg-jade-4 { background-color: var(--jade-4); }
    .bg-jade-5 { background-color: var(--jade-5); }
    .bg-jade-6 { background-color: var(--jade-6); }
    .bg-jade-7 { background-color: var(--jade-7); }
    .bg-jade-8 { background-color: var(--jade-8); }
    .bg-jade-9 { background-color: var(--jade-9); }
    .bg-jade-10 { background-color: var(--jade-10); }
    .bg-jade-11 { background-color: var(--jade-11); }
    .bg-jade-12 { background-color: var(--jade-12); }
  `;
  document.head.appendChild(style);
};